import { render, staticRenderFns } from "./kuaishouApp.vue?vue&type=template&id=02a8ddd4&scoped=true&"
import script from "./kuaishouApp.vue?vue&type=script&lang=js&"
export * from "./kuaishouApp.vue?vue&type=script&lang=js&"
import style0 from "./kuaishouApp.vue?vue&type=style&index=0&id=02a8ddd4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a8ddd4",
  null
  
)

export default component.exports